import React from 'react';

import { Image, ImageFit } from '@fluentui/react/lib/Image';
import Environment from '../../lib/Environment';

interface IClubImageCircle {
  escudo?: string;
  width: number;
  height: number;
  useMarginForGrid?: boolean;
  right?: boolean;
}

export const ClubImageCircle = (props: IClubImageCircle) => {
  const environment = new Environment();
  return (
    <Image
      src={props.escudo ? props.escudo : `${environment.getLocalBasePath()}/images/escudo_default.jpg`}
      imageFit={ImageFit.centerContain}
      maximizeFrame
      styles={{
        root: {
          // borderRadius: '50%',
          // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          width: `${props.width}px`,
          height: `${props.height}px`,
          marginLeft: props.useMarginForGrid ? 10 : 0,
          float: props.right ? 'right' : '',
        },
      }}
    />
  );
};

export default ClubImageCircle;
